export const STATE_SETTINGS = {
  jwksState: {
    key: "EncryptionContext_jwksContext",
    defaultValue: {},
  },
};
